(function ($) {
    $.nette.ext('select-with-links', {
        init() {
            const self = this;

            this.ext('snippets', true).after($.proxy(($el) => {
                const $elements = $($el).find('select.with-links');
                self.after($elements);
            }, this));

            self.after($('select.with-links'));
        },
    }, {
        after($elements) {
            $elements.on('change', function () {
                const $option = $(this).children(':selected');
                const url = $option.val();
                const type = $option.attr('data-type');

                if (type === 'redirect') {
                    window.location.href = url;
                } else {
                    $.nette.ajax({type: 'GET', url});
                }
            });
        },
    });
}(jQuery));
